import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { loadConfig } from '../../env/config_util';
import SimpleLogin from '../../components/SimpleLogin';
import { useDemoAuth } from '../../auth/DemoAuthProvider';

const LoginPage = () => {
  const config = loadConfig();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const demoAuth = useDemoAuth?.() || null;

  // If already authenticated, redirect to dashboard
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!config.config_module.demo_mode) {
    // In production, Auth0 handles login via redirect — this page is just a placeholder
    return null;
  }

  const handleLoginSuccess = async (userData) => {
    // SimpleLogin already stores tokens; just navigate
    navigate('/dashboard', { replace: true });
  };

  return <SimpleLogin onLoginSuccess={handleLoginSuccess} />;
};

export default LoginPage;
